var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.854 11.402 5.427-3.166v6.332l-5.426-3.166zm5.427 13.568-7.235 4.22-7.236-4.22v-7.387l7.235 4.22 7.236-4.22v7.387zM8.811 8.236l5.426 3.166-5.427 3.166V8.236zm8.14 4.674 5.427 3.165-5.427 3.166v-6.33zm-1.81 6.331-5.426-3.165 5.427-3.166v6.331zM22.378 6.73l-6.332 3.617-6.331-3.618 6.331-3.77 6.332 3.769zM7 6.125v19.748L16.045 31l9.045-5.126V6.126L16.045 1 7 6.126z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtm);
export default __webpack_public_path__ + "static/media/FTM.5a96e53583dac9f1be3300f289ca4632.svg";
export { ForwardRef as ReactComponent };